import { centerCrop, makeAspectCrop, PercentCrop } from 'react-image-crop';

export function makeCenteredSquareCrop(
  imageWidth: number,
  imageHeight: number
): PercentCrop {
  return centerCrop(
    makeAspectCrop({ unit: '%', width: 100 }, 1, imageWidth, imageHeight),
    imageWidth,
    imageHeight
  );
}
